<template>
  <div>
    <dialog-v2
      :show="show"
      :title="dialogTitle"
      max-width="600px"
      @close="closeDialog"
      @save="save">
      <template slot="content">
        <v-layout row wrap>
          <v-flex md10 pr-4>
            <v-text-field
              v-model="form.name"
              v-validate="'required|max:100'"
              data-vv-name="name"
              data-vv-scope="modal-filter"
              data-vv-as="nombre"
              :error-messages="errors.collect('name')"
              label="Nombre"
              color="black"/>
          </v-flex>
          <v-flex md2>
            <v-text-field
              v-model.number="form.order"
              v-validate="`required|integer|min_value:1|max_value:${maxOrder}`"
              data-vv-name="order"
              data-vv-scope="modal-filter"
              data-vv-as="order"
              :error-messages="errors.collect('order')"
              label="Orden"
              color="black"/>
          </v-flex>
        </v-layout>
        <v-layout row wrap mb-4>
          <v-flex md4>
            <v-switch
              label="No gestionar"
              v-model="form.no_management"
              class="k-blue-linear-text"
              :hide-details="true">
            </v-switch>
          </v-flex>
        </v-layout>
        <template v-if="!form.no_management">
          <v-layout row wrap>
            <v-flex :md7="form.type_id === 2">
              <v-select
                v-model="form.type_id"
                :items="types"
                item-value="id"
                item-text="label"
                v-validate="'required'"
                data-vv-scope="modal-filter"
                data-vv-name="type"
                data-vv-as="Tipo"
                :error-messages="errors.collect('type_id')"
                label="Tipo de gestión"
                color="black">
              </v-select>
            </v-flex>
            <v-flex md5 pl-4 v-if="form.type_id === 2">
              <v-text-field
                v-model="form.fixed_hour"
                label="Hora"
                ref="hour"
                type="time"
                v-validate="'required'"
                data-vv-name="hour"
                data-vv-scope="modal-filter"
                :error-messages="errors.collect('fixed_hour')"
                color="black">
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="align-center">
            <v-flex>
              <h3 mb-0>
                Ventana de tiempo Humano
              </h3>
            </v-flex>
            <v-flex md2>
              <v-text-field
                v-model.number="form.days_off_g1"
                v-validate="'required|integer'"
                data-vv-name="days_off_g1"
                data-vv-scope="modal-filter"
                data-vv-as="ventana de tiempo grupo humano"
                color="black"
                :error-messages="errors.collect('days_off_g1')"/>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="align-center">
            <v-flex>
              <h3 mb-0>
                Ventana de tiempo BOT/IVR
              </h3>
            </v-flex>
            <v-flex md2>
              <v-text-field
                v-model.number="form.days_off_g2"
                v-validate="'required|integer'"
                data-vv-name="days_off_g2"
                data-vv-scope="modal-filter"
                data-vv-as="ventana de tiempo grupo bot/ivr"
                color="black"
                :error-messages="errors.collect('days_off_g2')"/>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="align-center">
            <v-flex>
              <h3 mb-0>
                Ventana de tiempo SMS
              </h3>
            </v-flex>
            <v-flex md2>
              <v-text-field
                v-model.number="form.days_off_g3"
                v-validate="'required|integer'"
                data-vv-name="days_off_g3"
                data-vv-scope="modal-filter"
                data-vv-as="ventana de tiempo grupo sms"
                color="black"
                :error-messages="errors.collect('days_off_g3')"/>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="align-center">
            <v-flex>
              <h3 mb-0>
                Ventana de tiempo Email
              </h3>
            </v-flex>
            <v-flex md2>
              <v-text-field
                v-model.number="form.days_off_g4"
                v-validate="'required|integer'"
                data-vv-name="days_off_g4"
                data-vv-scope="modal-filter"
                data-vv-as="ventana de tiempo grupo email"
                color="black"
                :error-messages="errors.collect('days_off_g4')"/>
            </v-flex>
          </v-layout>
          <v-layout v-if="isWhatsappOutboundActive" row wrap class="align-center">
            <v-flex>
              <h3 mb-0>
                Ventana de tiempo WhatsApp
              </h3>
            </v-flex>
            <v-flex md2>
              <v-text-field
                v-model.number="form.days_off_g5"
                v-validate="'required|integer'"
                data-vv-name="days_off_g5"
                data-vv-scope="modal-filter"
                data-vv-as="ventana de tiempo grupo whatsapp"
                color="black"
                :error-messages="errors.collect('days_off_g5')"/>
            </v-flex>
          </v-layout>
          <v-subheader class="pl-0">
            Canales
          </v-subheader>
          <v-layout row wrap  mb-4>
            <v-flex
              :md2="!isWhatsappOutboundActive"
              v-for="channel in filteredChannels"
              :key="`channel-${channel.id}`"
              class="text-xs-center">
              <v-menu
                :close-on-content-click="channel.name !== 'sms' && channel.name !== 'bot' && channel.name !== 'ivr'"
                offset-y
                :disabled="!canEditWhatsappWorkflow && channel.name === 'whatsapp'"
                attach="channels-btn">
                <v-btn
                  icon
                  slot="activator"
                  :class="{ 'k-orange-linear-text': form[`send_${channel.name}`] }"
                  class="channels-btn">
                  <v-icon>
                    {{ channel.icon }}
                  </v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="$set(form, `send_${channel.name}`, +(!form[`send_${channel.name}`]))">
                    <v-list-tile-title>
                      {{ form[`send_${channel.name}`] ? 'Desactivar' : 'Activar' }}
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="openTemplateDialog(channel.name)">
                    <v-list-tile-title>Plantilla</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="['bot', 'sms', 'ivr', 'email', 'whatsapp'].includes(channel.name)
                    && (
                      (
                        channel.name !== 'bot'
                        && channel.name !== 'ivr'
                        && filter.template_id
                        && filter[channel.name]
                      )
                      || (
                        channel.name === 'bot'
                        && filter.id
                        && filter.bot_template_id
                      )
                      || (
                        channel.name === 'ivr'
                        && filter.id
                        && filter.ivr_template_id
                      )
                      || (
                        channel.name === 'whatsapp'
                        && filter.id
                        && filter.whatsapp_template_id
                      )
                    )"
                    @click="testTemplate(channel.name, channel.id)">
                    <v-list-tile-title>Probar</v-list-tile-title>
                  </v-list-tile>
                  <!-- <v-list-tile v-if="channel.name === 'sms'">
                    <v-checkbox
                      v-model="form.valid_only_sms"
                      :hide-details="true"
                      class="custom-checkbox"
                      label="Solo números validos" />
                  </v-list-tile>
                  <v-list-tile v-if="channel.name === 'sms'">
                    <v-checkbox
                      v-model="form.only_contacted_sms"
                      :hide-details="true"
                      class="custom-checkbox"
                      label="Solo contacto directo" />
                  </v-list-tile> -->
                  <v-list-tile
                    v-if="channel.id === 2 && channel.id !== 1 && channel.id !== 10"
                    @click="openChannelConfigDialog(channel.id)"
                  >
                    <v-list-tile-title>Configuración</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="channel.name === 'bot'">
                    <v-checkbox
                      v-model="form.bot_calls_queue"
                      :value="1"
                      :hide-details="true"
                      class="custom-checkbox"
                      label="Prioridad Alta" />
                  </v-list-tile>
                  <v-list-tile
                    v-if="channel.name === 'bot'">
                    <v-checkbox
                      v-model="form.bot_calls_queue"
                      :value="2"
                      :hide-details="true"
                      class="custom-checkbox"
                      label="Prioridad Media" />
                  </v-list-tile>
                  <v-list-tile
                    v-if="channel.name === 'bot'">
                    <v-checkbox
                      v-model="form.bot_calls_queue"
                      :value="3"
                      :hide-details="true"
                      class="custom-checkbox"
                      label="Prioridad Baja" />
                  </v-list-tile>
                  <v-list-tile
                    v-if="channel.name === 'ivr'">
                    <v-checkbox
                      v-model="form.ivr_calls_queue"
                      :value="1"
                      :hide-details="true"
                      class="custom-checkbox"
                      label="Prioridad Alta" />
                  </v-list-tile>
                  <v-list-tile
                    v-if="channel.name === 'ivr'">
                    <v-checkbox
                      v-model="form.ivr_calls_queue"
                      :value="2"
                      :hide-details="true"
                      class="custom-checkbox"
                      label="Prioridad Media" />
                  </v-list-tile>
                  <v-list-tile
                    v-if="channel.name === 'ivr'">
                    <v-checkbox
                      v-model="form.ivr_calls_queue"
                      :value="3"
                      :hide-details="true"
                      class="custom-checkbox"
                      label="Prioridad Baja" />
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
          </v-layout>
        </template>
        <filters-list v-model="form.filters" :default-filters="form.filters" :key="filtersListKey"/>
      </template>
    </dialog-v2>
    <template-dialog
      :show="templateDialog"
      :channel="templateChannel"
      :template="template"
      :template-staging="templateStaging"
      :activate-check="activateCheck"
      :append-vars="templateVars"
      :filter="form"
      @save="saveTemplate"
      @close="templateDialog = false" />
    <bot-templates-dialog
      :show="botTemplatesDialog"
      :botTemplate="botTemplate"
      @save="saveBotTemplate"
      @close="botTemplatesDialog = false" />
    <ivr-templates-dialog
      :show="ivrTemplatesDialog"
      :ivrTemplate="ivrTemplate"
      @save="saveIvrTemplate"
      @close="ivrTemplatesDialog = false" />
    <test-template-dialog
      :show="testTemplateDialog"
      :template-id="testTemplateId"
      :channel="templateChannelId"
      @close="testTemplateDialog = false" />
    <channel-config-dialog
      v-model="form"
      v-bind="channelConfigDialog"
      @close="channelConfigDialog.show = false"
    />
    <whatsapp-templates-dialog
      :show="whatsappTemplatesDialog"
      :workflow-filter="whatsappTemplate"
      :isPaymentType="false"
      :is-in-release="false"
      :is-new-workflow="false"
      @save="saveWhatsappTemplate"
      @close="whatsappTemplatesDialog = false"
    />
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import Scrollbar from 'vue-perfect-scrollbar';
import DialogV2 from '@/components/global/DialogV2';
import TemplateDialog from '@/components/Templates/Index';
import BotTemplatesDialog from '@/components/V2CollectWorkflows/Detail/WorkflowTree/BotTemplates';
import IvrTemplatesDialog from '@/components/V2CollectWorkflows/Detail/WorkflowTree/IvrTemplates';
import TestTemplateDialog from '@/components/Templates/TestDialog';
import ChannelConfigDialog from '@/components/V2CollectWorkflows/ChannelConfigDialog';
import FiltersList from '@/components/global/CustomerFilters/Index';
import channelsMixin from '@/mixins/channelsV2';
import filtersMixin from '@/mixins/workflowFilters';
import permissionsMixin from '@/mixins/permissions';
import comparisonOperatorsMixin from '@/mixins/comparisonOperators';
import EventBus from '@/event-bus';
import { validateWhatsappTemplateForWorkflow } from '@/mixins/whatsappTemplateSelect';
import WhatsappTemplatesDialog from '@/components/V2CollectWorkflows/Detail/WorkflowTree/WhatsappTemplates';

const uuidv1 = require('uuid/v1');

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    stage: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    isWhatsappOutboundActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DialogV2,
    Scrollbar,
    TemplateDialog,
    BotTemplatesDialog,
    IvrTemplatesDialog,
    TestTemplateDialog,
    ChannelConfigDialog,
    FiltersList,
    WhatsappTemplatesDialog,
  },
  mixins: [
    channelsMixin,
    comparisonOperatorsMixin,
    permissionsMixin,
  ],
  data() {
    const emptyForm = {
      name: '',
      order: '',
      days_off: '',
      company_email_id: null,
      bot_template_id: null,
      ivr_template_id: null,
      whatsapp_template_id: null,
      colly_sms_template_id: null,
      colly_sms_sender_id: null,
      colly_email_template_id: null,
      colly_email_sender_id: null,
      colly_whatsapp_template_id: null,
      colly_whatsapp_sender_id: null,
      subject: '',
      send_human: 0,
      send_bot: 0,
      send_email: 0,
      send_sms: 0,
      send_ivr: 0,
      send_visit: 0,
      send_whatsapp: 0,
      no_management: false,
      valid_only_sms: false,
      only_contacted_sms: false,
      bot_calls_queue: 1,
      ivr_calls_queue: 1,
      ivr_max_attempts: 3,
      bot_max_attempts: 3,
      human: '',
      email: '',
      sms: '',
      ivr: '',
      visit: '',
      filters: {
        type: 'group',
        operator: 'and',
        items: [],
      },
      days_off_g1: 0,
      days_off_g2: 0,
      days_off_g3: 0,
      days_off_g4: 0,
      days_off_g5: 0,
      fixed_hour: '',
      type_id: 1,
      sms_cs_journey: null,
      sms_check_days: null,
      sms_owner_id: null,
      ivr_owner_id: null,
      bot_owner_id: null,
      human_owner_id: null,
      whatsapp_owner_id: null,
    };
    return {
      emailStaging: {},
      smsStaging: {},
      filtersDialog: false,
      templateDialog: false,
      botTemplatesDialog: false,
      ivrTemplatesDialog: false,
      testTemplateDialog: false,
      whatsappTemplatesDialog: false,
      channelConfigDialog: {
        show: false,
        channelId: null,
      },
      templateChannel: '',
      templateChannelId: 0,
      emptyForm,
      form: _.cloneDeep(emptyForm),
      filtersListKey: uuidv1(),
      types: [
        {
          id: 1,
          label: 'Regular',
        },
        {
          id: 2,
          label: 'Dual hora fija',
        },
        {
          id: 3,
          label: 'Dual hora IA',
        },
      ],
    };
  },
  computed: {
    activateCheck() {
      return  (
        (
          this.templateChannel === 'email'
          || this.templateChannel === 'sms'
        )
        && (this.filter || {}).template_id
        && !!(this.filter || {})[this.templateChannel]
      );
    },
    templateStaging() {
      if (this.templateChannel === 'email') {
        return this.emailStaging && this.emailStaging || {};
      } else {
        return this.smsStaging && this.smsStaging || {};
      }
    },
    maxOrder() {
      let order = (this.stage.filters || []).length;
      if (!Object.keys(this.filter).length) {
        order += 1;
      }
      return order;
    },
    testTemplateId() {
      let id = 0;
      if (this.templateChannelId === 4) {
        id = this.form.bot_template_id;
      } else if (this.templateChannelId === 3) {
        id = this.form.ivr_template_id;
      } else if (this.templateChannelId === 7) {
        id = this.form.whatsapp_template_id;
      } else {
        id = this.filter.template_id || 0;
      }
      return id;
    },
    template() {
      return {
        ...this.templateChannel === 'email' && {
          company_email_id: this.form.company_email_id,
          subject: this.form.subject,
        },
        text: this.form[this.templateChannel] || '',
      };
    },
    editMode() {
      return Object.keys(this.filter).length > 0;
    },
    dialogTitle() {
      return `${!Object.keys(this.filter).length ? 'Crear' : 'Editar'} estrategia`;
    },
    filteredChannels() {
      const includedChannels = ['email', 'sms', 'ivr', 'bot', 'human', 'visit'];
      if (this.isWhatsappOutboundActive) {
        includedChannels.push('whatsapp');
      }
      return this.channels.filter(item => includedChannels.includes(item.name));
    },
    botTemplate() {
      return {
        bot_template_id: this.form.bot_template_id,
        max_attempts: this.form.bot_max_attempts,
      };
    },
    ivrTemplate() {
      return {
        ivr_template_id: this.form.ivr_template_id,
        max_attempts: this.form.ivr_max_attempts,
      };
    },
    whatsappTemplate() {
      return {
        whatsapp_template_id: this.form.whatsapp_template_id,
        colly_whatsapp_template_id: this.form.colly_whatsapp_template_id,
        colly_whatsapp_sender_id: this.form.colly_whatsapp_sender_id,
      };
    },
    canEditWhatsappWorkflow() {
      return this.checkPermissions([
        'edit_whatsapp_workflow',
      ]);
    },
  },
  methods: {
    setStaging() {
      this.axios.get(`templates/staging/${this.filter.template_id}`)
        .then(response => {
          const { data } = response;
          if (data.length) {
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              if (element.channel_id === 1) {
                this.emailStaging = {...element, text: element.body};
                delete this.emailStaging.body;
              } else if (element.channel_id === 2) {
                this.smsStaging = {...element, text: element.body};
                delete this.smsStaging.body;
              }
            }
          } else {
            this.emailStaging = {};
            this.smsStaging = {};
          }
        })
        .catch(() => {
          this.emailStaging = {};
          this.smsStaging = {};
        });
    },
    testTemplate(templateChannel, id) {
      this.templateChannel = templateChannel;
      this.templateChannelId = id;
      this.testTemplateDialog = true;
    },
    openTemplateDialog(templateChannel) {
      this.templateChannel = templateChannel;
      if (templateChannel === 'bot') {
        this.botTemplatesDialog = true;
      } else if (templateChannel === 'ivr') {
        this.ivrTemplatesDialog = true;
      } else if (templateChannel === 'whatsapp') {
        this.whatsappTemplatesDialog = true;
      } else {
        this.templateDialog = true;
      }
    },
    saveTemplate(form) {
      if (form.momentToApply === 'now' || !['create', 'update'].includes(form.actionType)) {
        const templateForm = {
          ...this.templateChannel === 'email' && {
            company_email_id: form.company_email_id,
            subject: form.subject,
          },
          [this.templateChannel]: form.text,
          ...form.colly_template_id && {
            [`colly_${this.templateChannel}_template_id`]: form.colly_template_id,
            [`colly_${this.templateChannel}_sender_id`]: form.colly_sender_id,
          },
        };
        this.form = {
          ...this.form,
          ...templateForm,
        };
        if (this.activateCheck) {
          this.axios.patch(`v2/workflow_filters/${this.filter.id}`, {
            ...templateForm,
          })
            .then((response) => {
              this.$emit('updated', response.data);
            })
            .catch(() => {});
        }
      } else {
        if (form.channel === 'email') {
          this.emailStaging = form;
          form.channel_id = 1;
        } else {
          this.smsStaging = form;
          form.channel_id = 2;
        }

        if (form.actionType === 'create') {
          this.axios.post('templates/staging', {
            ...form,
            company_id: this.$auth.user().company_id,
            template_id: this.filter.template_id,
            type: 'workflow_notification',
          })
          .then(() => EventBus.$emit('modal', 'Guardado exitoso'))
          .catch(() => EventBus.$emit('modal', 'Error al guardar, por favor intente nuevamente'));
        } else if (form.actionType === 'update') {
          this.axios.patch(`templates/staging/${this.filter.template_id}`, {
            ...form,
            company_id: this.$auth.user().company_id,
            template_id: this.filter.template_id,
            type: 'workflow_notification',
          })
          .then(() => EventBus.$emit('modal', 'Plantilla actualizada con éxito'))
          .catch(() => EventBus.$emit('modal', 'Error al guardar, por favor intente nuevamente'))
        }
      }
    },
    closeDialog() {
      this.$emit('close');
      setTimeout(() => {
        this.form = {
          ...this.emptyForm,
        };
        this.filters = [];
      }, 200);
    },
    async save() {
      let pass = true;
      if (!this.form.no_management) {
        const wrongChannels = this.channels.filter(item => item.name !== 'bot' && item.name !== 'ivr' && item.name !== 'human' && item.name !== 'whatsapp')
          .filter(item => this.form[`send_${item.name}`] && !this.form[item.name] && !this.form[`colly_${item.name}_template_id`]);
        if (this.form.send_bot && !this.form.bot_template_id) {
          wrongChannels.push({
            text: 'Bot',
          });
        }
        if (this.form.send_ivr && !this.form.ivr_template_id) {
          wrongChannels.push({
            text: 'Ivr',
          });
        }
        if (this.form.send_whatsapp
          && !this.form.colly_whatsapp_template_id
          && !this.form.whatsapp_template_id) {
          wrongChannels.push({
            text: 'WhatsApp',
          });
        }
        if (wrongChannels.length) {
          pass = false;
          EventBus.$emit('modal', `Los siguientes canales no tienen texto: ${wrongChannels.map(item => item.text).join(', ')}.`);
        }
        // Las plantillas colly ya vienen filtradas por aprobadas desde la API.
        if (pass && this.form.send_whatsapp && !this.form.colly_whatsapp_template_id) {
          const whatsappValidation = await validateWhatsappTemplateForWorkflow(
            this.axios,
            this.form.whatsapp_template_id,
          );
          if (!whatsappValidation.valid) {
            pass = false;
            EventBus.$emit('modal', whatsappValidation.message);
          }
        }
        const activeChannels = this.channels.filter(item => this.form[`send_${item.name}`]).length !== 0;
        if (!activeChannels) {
          pass = false;
          EventBus.$emit('modal', 'Debe activar al menos un canal');
        }
      }
      if (pass) {
        this.$validator.validateAll('modal-filter').then((validation) => {
          if (validation) {
            // Con plantilla colly no se manda la legacy de WhatsApp, para no pisarla.
            const omitted = this.form.colly_whatsapp_template_id ? ['whatsapp_template_id'] : [];
            const form = {
              ..._.omit(this.form, ['filters', 'no_management', ...omitted]),
            };
            form.filters = JSON.stringify(this.form.filters);
            form.no_management = this.form.no_management ? 1 : 0;
            form.fixed_hour = this.form.fixed_hour ? moment(this.form.fixed_hour, 'HH:mm').format('HH:mm') : this.form.fixed_hour;
            if (Object.keys(this.filter).length) {
              this.axios.patch(`v2/workflow_filters/${this.filter.id}`, form)
                .then((response) => {
                  this.$emit('updated', response.data);
                  this.$emit('close');
                })
                .catch((e) => {
                  const keys = Object.keys(e.response.data.errors);
                  for(let i = 0; i < keys; i += 1) {
                    this.$validator.errors.add({
                      field: keys[i],
                      msg: e.response.data.errors[keys[i]][0],
                    });
                  }
                });
            } else {
              this.axios.post(`stages/${this.stage.id}/filters`, form)
                .then((response) => {
                  this.$emit('created', response.data);
                  this.$emit('close');
                }).catch((e) => {
                  const keys = Object.keys(e.response.data.errors);
                  for(let i = 0; i < keys; i += 1) {
                    this.$validator.errors.add({
                      field: keys[i],
                      msg: e.response.data.errors[keys[i]][0],
                    });
                  }
                });
            }
          }
        });
      }
    },
    saveBotTemplate(form) {
      this.form.bot_template_id = form.bot_template_id;
      this.form.bot_max_attempts = form.max_attempts;
    },
    saveWhatsappTemplate(form) {
      this.form.whatsapp_template_id = form.whatsapp_template_id;
      this.form.colly_whatsapp_template_id = form.colly_whatsapp_template_id;
      this.form.colly_whatsapp_sender_id = form.colly_whatsapp_sender_id;
    },
    saveIvrTemplate(form) {
      this.form.ivr_template_id = form.ivr_template_id;
      this.form.ivr_max_attempts = form.max_attempts;
    },
    openChannelConfigDialog(channelId) {
      this.channelConfigDialog = {
        show: true,
        channelId,
      };
    },
  },
  watch: {
    'form.no_management'() { // eslint-disable-line
      if (this.show && this.form.no_management) {
        this.filteredChannels.forEach((item) => {
          this.form[`send_${item.name}`] = 0;
        });
      }
    },
    show() {
      if (!this.editMode) {
        setTimeout(() => {
          this.form = {
            ..._.cloneDeep(this.emptyForm),
            order: this.stage.filters.length + 1,
          };
        }, 200);
      } else {
        this.form = {
          ..._.pick(this.filter, Object.keys(this.emptyForm)),
        };
      }
      if (!this.show) {
        setTimeout(() => {
          this.$validator.errors.remove('name', 'filter');
          this.$validator.errors.remove('days_off', 'filter');
          this.$validator.errors.remove('order', 'filter');
          this.$validator.errors.remove('fixed_hour', 'filter');
        }, 500);
      }
      this.filtersListKey = uuidv1();
      if (this.activateCheck) {
        this.setStaging();
      }
    },
  },
};
</script>

<style scoped>
.custom-checkbox {
  width: 210px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/WorkflowTree/FilterModal.vue